module.exports = __webpack_public_path__ + "static/media/1P.7c06f997.svg";